export default "__VITE_ASSET__TyKD3iuy__"